
export const environment = {
   production: false,
   //apiUrl: "http://ec2-3-88-251-252.compute-1.amazonaws.com",
   //apiUrl:"http://localhost:4000",
   apiUrl: "https://api.abaschedulezipper.com",
   googleMapsApi: "AIzaSyDh6qxFOLr_SIvSglhLKWWA70DRlvrpyq4",
   siteKey: "AIzaSyDh6qxFOLr_SIvSglhLKWWA70DRlvrpyq4"
};
